import React, { useRef, useState } from 'react';
import html2pdf from 'html2pdf.js';
import { savePDFForm } from './supabaseService';

const styles = {
  container: {
    maxWidth: 600,
    margin: '40px auto',
    padding: 24,
    background: '#fff',
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    boxSizing: 'border-box',
    width: '100%',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    flexWrap: 'wrap',
  },
  logo: {
    width: 180,
    height: 'auto',
    maxWidth: '100%',
  },
  contactInfo: {
    textAlign: 'right',
    flex: 1,
    marginLeft: 20,
    fontSize: 15,
  },
  inputSection: {
    marginBottom: 20,
  },
  label: {
    fontWeight: 'bold',
    marginBottom: 5,
    display: 'block',
    fontSize: 16,
  },
  input: {
    width: '100%',
    padding: 10,
    border: '1px solid #ccc',
    borderRadius: 5,
    marginBottom: 10,
    backgroundColor: '#f2f2f2',
    fontSize: 16,
    boxSizing: 'border-box',
  },
  button: {
    padding: '14px 32px',
    background: '#ff0000',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    fontWeight: 'bold',
    fontSize: 18,
    cursor: 'pointer',
    marginTop: 24,
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    maxWidth: 350,
  },
  footer: {
    textAlign: 'center',
    marginTop: 30,
    fontWeight: 'bold',
    fontSize: 16,
  },
  '@media (max-width: 600px)': {
    container: {
      padding: 8,
    },
    header: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 4,
    },
    logo: {
      width: '100%',
      maxWidth: 200,
    },
    contactInfo: {
      marginLeft: 0,
      fontSize: 14,
    },
    input: {
      fontSize: 15,
      padding: 8,
    },
    button: {
      fontSize: 16,
      padding: '12px 16px',
    },
  },
};

const LOGO_URL = '/logo.jpg';

export default function Form3Screen() {
  const [formValues, setFormValues] = useState({
    siteAddress: '',
    biohazardReport: '',
  });

  const pdfRef = useRef();

  const handleInputChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    generatePDF();
  };

  const generatePDF = async () => {
    try {
      const element = pdfRef.current;
      
      // Generate PDF as blob
      const pdfBlob = await html2pdf()
        .set({
          margin: 0.5,
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        })
        .from(element)
        .outputPdf('blob');

      // Create filename with form name + date
      const currentDate = new Date().toISOString().split('T')[0];
      const fileName = `Biohazard_Report_Form_${currentDate}.pdf`;

      // Save to Firebase
      const formData = {
        formType: 'form3',
        title: 'Biohazard Report Form',
        location: formValues.siteAddress || 'Not specified',
        createdBy: 'Not specified',
        siteAddress: formValues.siteAddress || 'Not specified',
        biohazardReport: formValues.biohazardReport || 'Not specified',
        reportDate: currentDate
      };

      await savePDFForm(formData, pdfBlob, fileName);
      
      // Also download locally for user convenience
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      alert('PDF saved to library and downloaded successfully!');
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit}>
        <div style={styles.header}>
          <img src={LOGO_URL} alt="Logo" style={styles.logo} />
          <div style={styles.contactInfo}>
            <div>18 Rosebridge Court</div>
            <div>Rosebridge Way</div>
            <div>Ince in Makerfield</div>
            <div>01942 517359</div>
            <div>info@marriedtothemop.co.uk</div>
          </div>
        </div>
        <div style={styles.inputSection}>
          <label style={styles.label}>Site Address</label>
          <input
            style={styles.input}
            name="siteAddress"
            value={formValues.siteAddress}
            onChange={handleInputChange}
            placeholder="Site Address"
          />
          <label style={styles.label}>Biohazard Report</label>
          <input
            style={styles.input}
            name="biohazardReport"
            value={formValues.biohazardReport}
            onChange={handleInputChange}
            placeholder="Biohazard Report"
          />
        </div>
        <button style={styles.button} type="submit">Download PDF</button>
      </form>

      {/* Hidden PDF template */}
      <div style={{ display: 'none' }}>
        <div ref={pdfRef}>
          <html>
            <head>
              <style>
                {`
                body { font-family: Arial, sans-serif; }
                .container { width: 100%; padding: 20px; box-sizing: border-box; }
                .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; }
                .contact-info { text-align: right; }
                .contact-info p { margin: 0; }
                .input-section { margin-bottom: 20px; }
                .input-label { font-weight: bold; margin-bottom: 5px; }
                .input-value { padding: 10px; border: 1px solid #ccc; border-radius: 5px; margin-bottom: 10px; background-color: #f2f2f2; height: 50px; }
                .footer { text-align: center; margin-top: 30px; font-weight: bold; }
                .logo { width: 180px; height: auto; max-width: 100%; }
                @media (max-width: 600px) {
                  .header { flex-direction: column; align-items: stretch; gap: 4px; }
                  .logo { width: 100%; max-width: 200px; }
                  .contact-info { margin-left: 0; font-size: 14px; }
                }
                `}
              </style>
            </head>
            <body>
              <div class="container">
                <div class="header">
                  <img src={LOGO_URL} alt="Logo" class="logo" />
                  <div class="contact-info">
                    <p>18 Rosebridge Court</p>
                    <p>Rosebridge Way</p>
                    <p>Ince in Makerfield</p>
                    <p>01942 517359</p>
                    <p>info@marriedtothemop.co.uk</p>
                  </div>
                </div>
                <div class="input-section">
                  <div>
                    <p class="input-label">Site Address:</p>
                    <div class="input-value">{formValues.siteAddress}</div>
                  </div>
                  <div>
                    <p class="input-label">Biohazard Report:</p>
                    <div class="input-value">{formValues.biohazardReport}</div>
                  </div>
                </div>
                <div class="footer">
                  Married to the Mop Northwest Ltd
                </div>
              </div>
            </body>
          </html>
        </div>
      </div>
    </div>
  );
}
